"use client";

import React, { createContext, useContext, useState } from "react";

type ContextProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const WatchlistContext = createContext<ContextProps>({
  isOpen: false,
  setIsOpen: () => 0,
});

export const useWatchlistContext = () => useContext(WatchlistContext);

type ContainerProps = {
  isWatchlistOpen?: boolean;
  children: React.ReactNode;
};

export const WatchlistContextProvider = ({
  isWatchlistOpen = false,
  children,
}: ContainerProps) => {
  const [isOpen, setIsOpen] = useState(isWatchlistOpen);
  return (
    <WatchlistContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </WatchlistContext.Provider>
  );
};
